import { Document, Page, StyleSheet } from '@react-pdf/renderer';
import CssfPdfBusinessSkillsSection from "./CssfPdfBusinessSkillsSection";
import CssfPdfDiplomasSection from "./CssfPdfDiplomasSection";
import CssfPdfExperiencesSection from "./CssfPdfExperiencesSection";
import CssfPdfFooter from "./CssfPdfFooter";
import CssfPdfHeader from "./CssfPdfHeader";
import CssfPdfLanguageSkillsSection from "./CssfPdfLanguageSkillsSection";
import CssfPdfUserInformation from "./CssfPdfUserInformation";

export default function CssfPdf( { resumeData, translations } ) {

     // Note: styles for document should use 'mm' or 'cm' as units instead of 'px'
    const styles = StyleSheet.create( {
        page: {
            flexDirection: 'column',
            fontSize: '10pt',
            fontFamily: 'Arial, sans-serif',
            textAlign: 'justify',
            paddingBottom: '80px',
            paddingTop: '110px',
            paddingHorizontal: '40px',
        },
    } );

    return (
        <Document>
            <Page size="A4" style={ styles.page }>
                <CssfPdfHeader resumeData={ resumeData }/>
                <CssfPdfUserInformation resumeData={ resumeData }/>
                <CssfPdfExperiencesSection resumeData={ resumeData } translations={ translations }/>
                <CssfPdfDiplomasSection resumeData={ resumeData } translations={ translations }/>
                <CssfPdfLanguageSkillsSection resumeData={ resumeData } translations={ translations }/>
                <CssfPdfBusinessSkillsSection resumeData={ resumeData }/>
                <CssfPdfFooter/>
            </Page>
        </Document>
    );
}
